var inactivityTimer;
var keepAliveTimer;
var tickTimer;
var countdownTimer;

var countdownTimes;

var inactivityControl = {};
// initialize from razor
inactivityControl.logoutUrl = "";
inactivityControl.keepSessionAliveUrl = null;

/* page defined methods */

function pageMethodCountdownStop() { };
function pageMethodCountdownStart(countdownTimes) { };
function pageMethodTick() { };

function getSessionKeepAlliveTimerMilliseconds() {
    return 15 * 60 * 1000;
}

function getInactivityTimerMilliseconds() {
    return 29 * 60 * 1000;
}

function getTickTimerMilliseconds() {
    return 5 * 60 * 1000;
}

function getCountdownMilliseconds() {
    return 1000;
}

function pageMethodLogoutUser() {
    if (inactivityControl.logoutUrl !== "") {
        window.location.href = inactivityControl.logoutUrl;
    }
}

inactivityControl.keepSessionAlive = function () {
    $.ajax({
        type: "POST",
        url: inactivityControl.keepSessionAliveUrl,
        cache: false
    });
}

function InactivityControlStart() {
    InactivityControlReset();
    window.clearInterval(tickTimer);
    tickTimer = window.setInterval(CallPageMethodTick, getTickTimerMilliseconds());

    //document.addEventListener("mousemove", InactivityControlReset, false);
    document.addEventListener("mousedown", InactivityControlReset, false);
    document.addEventListener("keypress", InactivityControlReset, false);
    //document.addEventListener("DOMMouseScroll", InactivityControlReset, false);
    //document.addEventListener("mousewheel", InactivityControlReset, false);
    //document.addEventListener("touchmove", InactivityControlReset, false);
    //document.addEventListener("MSPointerMove", InactivityControlReset, false);
}

function InactivityControlReset(e) {
    window.clearInterval(countdownTimer);
    window.clearTimeout(inactivityTimer);
    window.clearTimeout(keepAliveTimer);

    if (typeof e !== 'undefined' && $(e.target).hasClass("sp-keep-signed-logout") == true) {
        return;
    }

    CallPageMethod(pageMethodCountdownStop);
    keepAliveTimer = window.setTimeout(inactivityControl.keepSessionAlive, getSessionKeepAlliveTimerMilliseconds());
    inactivityTimer = window.setTimeout(CallInactivityCountdown, getInactivityTimerMilliseconds());
}

function CallInactivityCountdown() {
    CallPageMethod(pageMethodCountdownStart);
    window.clearTimeout(inactivityTimer);
    window.clearTimeout(keepAliveTimer);
    countdownTimes = 60;
    countdownTimer = window.setInterval(CallCountdown, getCountdownMilliseconds());
}

function CallCountdown() {
    if (countdownTimes === 0) {
        CallInactivityFinished();
    } else {
        var isMethodDefined = typeof pageMethodCountdown === "function";
        if (isMethodDefined) {
            pageMethodCountdown(countdownTimes);
        }
        countdownTimes--;
    }
}

function CallInactivityFinished() {
    window.clearInterval(countdownTimer);
    window.clearTimeout(inactivityTimer);
    window.clearTimeout(keepAliveTimer);
    window.clearInterval(tickTimer);
    CallPageMethodTick();
    CallPageMethod(pageMethodLogoutUser);
}

function CallPageMethodTick() {
    CallPageMethod(pageMethodTick);
}

function CallPageMethod(pageMethod) {
    var isMethodDefined = typeof pageMethod === "function";
    if (isMethodDefined) {
        pageMethod();
    }
}

// start timer immediately after page is successfully loaded
$(document).ready(function () {
    InactivityControlStart();
});
